/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
// export const urls="http://47.104.173.17:9002/evaluate"
// export const urls = "https://api.51xiaoping.com/evaluate"//正式环境
// export const urls = "https://test.api.51xiaoping.com/evaluate"//测试环境
//export const urls="http://192.168.1.180:9002/evaluate"
//export const urls="http://192.168.1.113:9002/evaluate"
import {urls} from "../api/home.js"
import { POST, BASE_URL, down } from '../api/index'


// 获取全部公告
export function noticeList(params) {
	return POST(urls + '/notice/list', params, 'get', '')
}
// 获取公告详情
export function queryNotice(params) {
	return POST(urls + '/notice/' + params, '', 'get', '')
}

// 获取自己发布的公告
export function noticePubList(params) {
	return POST(urls + '/notice/pub/list', params, 'get', '')
}

//获取我收的公告列表
export function receiveList(params) {
	return POST(urls + '/notice/receive/list', params, 'get', '')
}

// 删除我发布的公告
export function deleteNotice(id, params) {
	return POST(urls + '/notice/' + id, params, 'delete', '')
}

// 获取树状数据  /notice/pub/receiverList
export function pubReceiverList(params) {
	return POST(urls + '/notice/pub/receiverList', params, 'get', '')
}

//新增/修改公告
export function UpdateNotice(params) {
	return POST(urls + '/notice', params, 'post', '')
}




// WEBPACK FOOTER //
// ./src/api/notice.js